export function set(key: string, value: string) {
  if (typeof document === 'undefined') return
  if (!localStorage) return

  localStorage.setItem(key, value)
}

// Not totally typesafe if something in local storage doesn't match it's type on read
export function get<T = any>(key: string): T | null {
  if (typeof document === 'undefined') return null
  if (!localStorage) return null

  const storedValue: unknown = localStorage.getItem(key)

  return storedValue ? (storedValue as T) : null
}

export function setObject(key: string, obj: any) {
  if (typeof document === 'undefined') return
  if (!localStorage) return null

  const value = JSON.stringify(obj)

  localStorage.setItem(key, value)
}

// Not totally typesafe if something in local storage doesn't match it's type on read
export function getObject<T = any>(key: string): T | null {
  if (typeof document === 'undefined') return null
  if (!localStorage) return null

  const value = localStorage.getItem(key)

  if (!value) return null

  try {
    return JSON.parse(value)
  } catch (err) {
    console.error(err)
    return null
  }
}

export function remove(key: string) {
  if (typeof document === 'undefined') return
  if (!localStorage) return

  localStorage.removeItem(key)
}

export default {
  set,
  get,
  setObject,
  getObject,
  remove,
}
